import axios from "axios";
import React, { useState, useEffect } from "react";
import host from "../host";
import imgLoc from "./imgLoc";
import Spinner from "../Spinner";

function Profile(props) {
  const student = props.student;
  const userCourse = props.userCourse;
  const [empire, setEmpire] = useState([]);
  const [adviser, setAdviser] = useState({
    firstname: "Loading Adivser",
    middleinitial: "",
    lastname: "",
  });
  const [totalUnits, setTotalUnits] = useState(0);
  const [completedUnits, setCompletedUnits] = useState(0);
  const [changePassState, setChangePassState] = useState(false);
  const [newPass, setNewPass] = useState("");
  const [newPassVerify, setNewPassVerify] = useState("");
  const [loadingBasic, setLoadingBasic] = useState(true);
  const [loadingAcads, setLoadingAcads] = useState(true);
  const [loadingPass, setLoadingPass] = useState(false);
  const [emailAddress, setEmailAddress] = useState(null);
  const [loadingEmail, setLoadingEmail] = useState(true);
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingCheck, setLoadingCheck] = useState(false);

  // Initial profile data fetch is intentionally one-time on mount.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getEmpire();
    getAdviser();
    loadAllUnits();
    loadCompletedUnits();
    loadEmailStatus();
  }, []);

  useEffect(() => {
    if (adviser.lastname === "") {
      return;
    }
    setLoadingBasic(false);
  }, [empire, adviser]);

  const getEmpire = () => {
    axios
      .post(`${host}getEmpire`, {
        newid: props.studentId,
      })
      .then((res) => {
        setEmpire(res.data);
      });
  };

  const getAdviser = () => {
    axios
      .post(`${host}getAdviser`, {
        newid: props.studentId,
      })
      .then((res) => {
        setAdviser(res.data[0]);
      });
  };

  const loadAllUnits = () => {
    axios
      .post(`${host}loadAllUnits`, {
        newid: props.studentId,
      })
      .then((res) => {
        let total = 0;
        for (let i = 0; i < res.data.length; i++) {
          total = total + res.data[i].units;
        }
        setTotalUnits(total);
      });
  };

  const loadCompletedUnits = () => {
    axios
      .post(`${host}loadCompletedUnits`, {
        newid: props.studentId,
      })
      .then((res) => {
        let total = 0;
        for (let i = 0; i < res.data.length; i++) {
          total = total + res.data[i].units;
        }
        setCompletedUnits(total);
        setLoadingAcads(false);
      });
  };

  const loadEmailStatus = () => {
    axios
      .post(`${host}getEmailStatus`, {
        studentId: props.studentId,
      })
      .then((res) => {
        if (res.data && res.data.email_address) {
          setEmailAddress(res.data.email_address);
        }
        setLoadingEmail(false);
      })
      .catch(() => {
        setLoadingEmail(false);
      });
  };

  const handleCreateEmail = () => {
    setLoadingCreate(true);
    axios
      .post(`${host}createInstitutionalEmail`, {
        studentId: props.studentId,
      })
      .then((res) => {
        if (res.data.success) {
          setEmailAddress(res.data.email);
          alert("Institutional email created successfully!");
        } else {
          alert(res.data.error || "Failed to create email");
        }
      })
      .catch((err) => {
        console.error("Error creating email:", err);
        alert("Failed to create email");
      })
      .finally(() => {
        setLoadingCreate(false);
      });
  };

  const handleCheckEmail = () => {
    setLoadingCheck(true);
    axios
      .post(`${host}checkExistingEmail`, {
        email: emailInput,
      })
      .then((res) => {
        if (res.data.inGoogleWorkspace) {
          // Auto-link if email exists in Google Workspace
          handleLinkEmail();
        } else {
          alert("Email is available for creation");
          setLoadingCheck(false);
        }
      })
      .catch((err) => {
        console.error("Error checking email:", err);
        alert("Failed to check email");
        setLoadingCheck(false);
      });
  };

  const handleLinkEmail = () => {
    axios
      .post(`${host}sendTransferInvitation`, {
        studentId: props.studentId,
        email: emailInput,
      })
      .then((res) => {
        if (res.data.success) {
          setEmailAddress(res.data.email);
          setShowEmailInput(false);
          setEmailInput("");
          alert("Email linked successfully!");
        } else {
          alert(res.data.error || "Failed to link email");
        }
      })
      .catch((err) => {
        console.error("Error linking email:", err);
        alert("Failed to link email");
      })
      .finally(() => {
        setLoadingCheck(false);
      });
  };

  const renderEmpire = () => {
    if (empire.length === 0) {
      return "TBA";
    } else {
      return empire[0].empirename;
    }
  };

  const studentImg = () => {
    return `${imgLoc}${props.studentId}.jpg`;
  };

  const newPassInput = (e) => {
    setNewPass(e.target.value);
  };

  const newPassVerifyInput = (e) => {
    setNewPassVerify(e.target.value);
  };

  const renderPassword = () => {
    if (changePassState) {
      return (
        <React.Fragment>
          <div>
            <input
              className="bg-slate-50 mb-2 p-2.5 rounded-xl transition-all duration-200 box-border w-full border border-slate-200 text-sm focus:outline-none focus:border-blue-500 focus:ring-3 focus:ring-blue-500/20 focus:bg-white focus:text-slate-900"
              type="password"
              placeholder="Enter New Password"
              onChange={newPassInput}
            />
          </div>
          <div>
            <input
              className="bg-slate-50 mb-2 p-2.5 rounded-xl transition-all duration-200 box-border w-full border border-slate-200 text-sm focus:outline-none focus:border-blue-500 focus:ring-3 focus:ring-blue-500/20 focus:bg-white focus:text-slate-900"
              type="password"
              placeholder="Verify New Password"
              onChange={newPassVerifyInput}
            />
          </div>
          <div className="flex items-end flex-col mt-1">
            <button
              className="bg-blue-600 text-white w-auto min-w-[5rem] p-2 rounded-xl font-semibold text-sm border-none shadow-sm hover:bg-blue-700"
              onClick={changePassword}
            >
              Apply
            </button>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div>*****************</div>
          <div
            className="text-sm cursor-pointer font-semibold text-blue-600 underline underline-offset-3 hover:text-blue-700"
            onClick={changePassword}
          >
            Change Password
          </div>
        </React.Fragment>
      );
    }
  };

  const changePassword = () => {
    if (changePassState) {
      setLoadingPass(true);
      if (newPass === newPassVerify) {
        axios
          .post(`${host}changePassword`, {
            newid: props.studentId,
            newPass: newPass,
          })
          .then((res) => {
            if (res.data === 1) {
              setChangePassState(false);
              alert("Password Changed Successfully!");
            } else {
              alert("Unknown error!");
            }
            setLoadingPass(false);
          });
      } else {
        alert("Password does not match! Please enter again.");
        setLoadingPass(false);
      }
    } else {
      setChangePassState(true);
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-1 pb-6 relative">
      {/* Loading Overlay */}
      {(loadingCreate || loadingCheck) && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-xl flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
            <p className="text-slate-700 font-semibold">
              {loadingCreate ? "Creating email..." : "Checking email..."}
            </p>
          </div>
        </div>
      )}
      <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900 mb-4">
        Student profile
      </h2>
      <div
        className="w-[200px] md:w-[200px] aspect-square max-w-full border-4 border-sky-400 mb-5 rounded-2xl bg-cover bg-center bg-no-repeat shadow-md"
        style={{ backgroundImage: `url(${studentImg()})` }}
        role="img"
        aria-label="Student photo"
      />
      <div className="bg-white p-4 rounded-2xl mb-4 border border-slate-200 shadow-sm">
        <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-3 text-center pb-2 border-b border-sky-200">
          Basic information
        </div>
        <div className="min-h-28">
          {loadingBasic || loadingEmail ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <div className="font-bold text-lg md:text-xl text-slate-800 leading-tight">
                {`${student.first_name} ${student.middle_name.charAt(
                  0,
                )}.${" "} ${student.last_name}`}
              </div>
              <div>
                {emailAddress ? (
                  <>
                    <div className="text-sm text-slate-700">{emailAddress}</div>
                    <div className="text-xs text-slate-500">
                      This is your official PEACI email address. You can use
                      this to access your PEACI email account.
                    </div>
                    <div className="text-xs text-rose-500 italic">
                      Default Password: changeme
                    </div>
                  </>
                ) : showEmailInput ? (
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                    <div className="flex items-center flex-1 w-full">
                      <input
                        type="text"
                        className="bg-slate-50 p-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:border-blue-500 flex-1"
                        placeholder="username"
                        value={emailInput}
                        onChange={(e) => setEmailInput(e.target.value)}
                      />
                      <span className="text-sm text-slate-500 ml-2">
                        @peaci.edu.ph
                      </span>
                    </div>
                    <div className="flex gap-2 w-full sm:w-auto">
                      <button
                        className="bg-blue-600 text-white px-3 py-2 rounded-lg text-sm font-semibold hover:bg-blue-700 flex-1 sm:flex-none"
                        onClick={handleCheckEmail}
                        disabled={loadingCheck}
                      >
                        {loadingCheck ? "..." : "✓"}
                      </button>
                      <button
                        className="bg-slate-200 text-slate-700 px-3 py-2 rounded-lg text-sm font-semibold hover:bg-slate-300 flex-1 sm:flex-none"
                        onClick={() => {
                          setShowEmailInput(false);
                          setEmailInput("");
                        }}
                      >
                        X
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex gap-2">
                    <button
                      className="text-xs bg-blue-600 text-white px-3 py-1.5 rounded-lg font-semibold hover:bg-blue-700"
                      onClick={handleCreateEmail}
                      disabled={loadingCreate}
                    >
                      {loadingCreate ? "..." : "Create Institutional Email"}
                    </button>
                    <button
                      className="text-xs bg-slate-200 text-slate-700 px-3 py-1.5 rounded-lg font-semibold hover:bg-slate-300"
                      onClick={() => setShowEmailInput(true)}
                    >
                      Link Institutional Email
                    </button>
                  </div>
                )}
              </div>
              <div>ID Number: {student.newid}</div>
              <div>
                Adviser: {adviser.firstname} {adviser.middleinitial.charAt(0)}
                {". "}
                {adviser.lastname}
              </div>
              <div>Empire: {renderEmpire()}</div>
            </React.Fragment>
          )}
        </div>
      </div>
      <div className="bg-white p-3 rounded-2xl mb-4 border border-slate-200 shadow-sm">
        <div className="border-b border-sky-200 text-slate-500 text-xs font-semibold uppercase tracking-wider mb-3 pb-2 text-center">
          Login details
        </div>
        {loadingPass ? (
          <Spinner />
        ) : (
          <div className="flex flex-wrap gap-3 items-start">
            <div className="flex-none min-w-[100px] md:min-w-[112px] text-sm font-semibold text-slate-500 pt-0.5">
              Password
            </div>
            <div className="flex-1 min-w-[192px] text-slate-700 text-sm leading-relaxed w-full md:flex-1">
              {renderPassword()}
            </div>
          </div>
        )}
      </div>
      <div className="bg-white p-3 rounded-2xl mb-4 border border-slate-200 shadow-sm">
        <div className="border-b border-sky-200 text-slate-500 text-xs font-semibold uppercase tracking-wider mb-3 pb-2 text-center">
          Academic information
        </div>
        {loadingAcads ? (
          <Spinner />
        ) : (
          <React.Fragment>
            <div className="flex flex-wrap gap-1 gap-x-3 p-2 border-b border-slate-100">
              <div className="flex-none min-w-[100px] md:min-w-[112px] text-sm font-semibold text-slate-500">
                LRN
              </div>
              <div className="flex-1 min-w-[192px] text-slate-700 text-sm leading-relaxed">
                <b>{student.lrnno}</b>
              </div>
            </div>
            <div className="flex flex-wrap gap-1 gap-x-3 p-2 border-b border-slate-100">
              <div className="flex-none min-w-[100px] md:min-w-[112px] text-sm font-semibold text-slate-500">
                Course
              </div>
              <div className="flex-1 min-w-[192px] text-slate-700 text-sm leading-relaxed">
                <div>{userCourse.course}</div>
                <div>{userCourse.description}</div>
              </div>
            </div>
            <div className="flex flex-wrap gap-1 gap-x-3 p-2 border-b border-slate-100">
              <div className="flex-none min-w-[100px] md:min-w-[112px] text-sm font-semibold text-slate-500">
                Standing
              </div>
              <div className="flex-1 min-w-[192px] text-slate-700 text-sm leading-relaxed">
                {student.yearlevel}
              </div>
            </div>
            <div className="flex flex-wrap gap-1 gap-x-3 p-2 border-b border-slate-100">
              <div className="flex-none min-w-[100px] md:min-w-[112px] text-sm font-semibold text-slate-500">
                Scholarship
              </div>
              <div className="flex-1 min-w-[192px] text-slate-700 text-sm leading-relaxed">
                {student.scholarship}
              </div>
            </div>
            <div className="flex flex-wrap gap-1 gap-x-3 p-2">
              <div className="flex-none min-w-[100px] md:min-w-[112px] text-sm font-semibold text-slate-500">
                Progress
              </div>
              <div className="flex-1 min-w-[192px] text-slate-700 text-sm leading-relaxed">
                <div style={{ fontWeight: 600 }}>
                  {((completedUnits / totalUnits) * 100).toFixed(2)}%{" "}
                </div>
                <div>
                  {completedUnits} out of {totalUnits} Units Completed
                </div>
                <div className="text-sm italic">
                  {totalUnits - completedUnits} Units remaining
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

export default Profile;
